import { useMutation } from '@tanstack/react-query';

import { typedApiClient } from '~/common/util/api-client';

export function useVARecoupmenTesttMutation(
  obfuscatedLenderDatabaseId,
  obfuscatedLoanRecordId,
) {
  return useMutation({
    mutationFn: async () => {
      await typedApiClient.v1.vaRecoupmentTest({
        obfuscatedLoanIdentifier: {
          obfuscatedLenderDatabaseId,
          obfuscatedLoanRecordId,
        },
      });
    },
  });
}
